import { ContentType } from 'types/publishedAssets';

export const DIVISOR = 10000;
export function splitSectionEntitiesByColumn(sectionEntities: ContentType[]) {
  const leftColumn: ContentType[] = [];
  const rightColumn: ContentType[] = [];
  sectionEntities.forEach((entity) => {
    const rowIndex = Math.floor(entity.entity_order || 0);
    const columnIndex = Math.round(((entity.entity_order || 0) - rowIndex) * DIVISOR);
    if (columnIndex === 0) {
      leftColumn.push(entity);
    } else {
      rightColumn.push(entity);
    }
  });
  return { leftColumn, rightColumn };
}
